import { Component, Input } from '@angular/core';
import { Badge, WdxBadgeModule } from '@wdx/shared/components/wdx-badge';
import {
    TranslateTokenisedStringPipe,
    WdxMarkdownToHtmlPipe,
} from '@wdx/shared/utils';

@Component({
    selector: 'wdx-audit-value',

    imports: [
        WdxBadgeModule,
        WdxMarkdownToHtmlPipe,
        TranslateTokenisedStringPipe,
    ],
    templateUrl: './wdx-audit-value.component.html',
    host: {
        class: 'd-flex flex-column h-100 justify-content-center text-break',
    },
})
export class WdxAuditValueComponent {
    @Input() label?: string;
    @Input() subtitle?: string;
    @Input() badge?: Badge;
}
